/* tslint:disable */
/* eslint-disable */
/**
 * PCO - Product & Services
 * API to test if access the application and get the current version
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PortfolioFieldKey } from './PortfolioFieldKey';
import {
    PortfolioFieldKeyFromJSON,
    PortfolioFieldKeyFromJSONTyped,
    PortfolioFieldKeyToJSON,
    PortfolioFieldKeyToJSONTyped,
} from './PortfolioFieldKey';
import type { PortfolioFieldLookupType } from './PortfolioFieldLookupType';
import {
    PortfolioFieldLookupTypeFromJSON,
    PortfolioFieldLookupTypeFromJSONTyped,
    PortfolioFieldLookupTypeToJSON,
    PortfolioFieldLookupTypeToJSONTyped,
} from './PortfolioFieldLookupType';

/**
 * 
 * @export
 * @interface PortfolioFieldRule
 */
export interface PortfolioFieldRule {
    /**
     * 
     * @type {PortfolioFieldKey}
     * @memberof PortfolioFieldRule
     */
    field: PortfolioFieldKey;
    /**
     * Whether the field is shown.
     * @type {boolean}
     * @memberof PortfolioFieldRule
     */
    visible: boolean;
    /**
     * Whether the field must be filled before the portfolio can be created.
     * @type {boolean}
     * @memberof PortfolioFieldRule
     */
    mandatory: boolean;
    /**
     * Whether the user may change the field.
     * @type {boolean}
     * @memberof PortfolioFieldRule
     */
    editable: boolean;
    /**
     * Value to prefill when the field is empty; omitted when there is no default.
     * @type {string}
     * @memberof PortfolioFieldRule
     */
    defaultValue?: string;
    /**
     * 
     * @type {PortfolioFieldLookupType}
     * @memberof PortfolioFieldRule
     */
    lookupType?: PortfolioFieldLookupType;
}



/**
 * Check if a given object implements the PortfolioFieldRule interface.
 */
export function instanceOfPortfolioFieldRule(value: object): value is PortfolioFieldRule {
    if (!('field' in value) || value['field'] === undefined) return false;
    if (!('visible' in value) || value['visible'] === undefined) return false;
    if (!('mandatory' in value) || value['mandatory'] === undefined) return false;
    if (!('editable' in value) || value['editable'] === undefined) return false;
    return true;
}

export function PortfolioFieldRuleFromJSON(json: any): PortfolioFieldRule {
    return PortfolioFieldRuleFromJSONTyped(json, false);
}

export function PortfolioFieldRuleFromJSONTyped(json: any, ignoreDiscriminator: boolean): PortfolioFieldRule {
    if (json == null) {
        return json;
    }
    return {
        
        'field': PortfolioFieldKeyFromJSON(json['field']),
        'visible': json['visible'],
        'mandatory': json['mandatory'],
        'editable': json['editable'],
        'defaultValue': json['defaultValue'] == null ? undefined : json['defaultValue'],
        'lookupType': json['lookupType'] == null ? undefined : PortfolioFieldLookupTypeFromJSON(json['lookupType']),
    };
}

export function PortfolioFieldRuleToJSON(json: any): PortfolioFieldRule {
    return PortfolioFieldRuleToJSONTyped(json, false);
}

export function PortfolioFieldRuleToJSONTyped(value?: PortfolioFieldRule | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'field': PortfolioFieldKeyToJSON(value['field']),
        'visible': value['visible'],
        'mandatory': value['mandatory'],
        'editable': value['editable'],
        'defaultValue': value['defaultValue'],
        'lookupType': PortfolioFieldLookupTypeToJSON(value['lookupType']),
    };
}

